var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:_vm.$style.root},[_c('li',{class:_vm.$style.parent},[_vm._t("parent")],2),_vm._v(" "),_vm._l((_vm.children),function(child){return _vm._t("item",function(){return [_c('li',{key:child.id},[_vm._v(_vm._s(child))])]},{"item":child})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }